import React from 'react'
import { S } from './KskBox.styles';

function KskBox({children, className = '' , style, highlight}) {
  return (
    <S.Section style={style} className={`ksk-box ${className}${highlight ? ' ksk-box--highlight' : '' }`}>
      { children }
    </S.Section>
  )
}

export default KskBox;
